module.exports = __webpack_public_path__ + "img/illustration-flowing-conversation.6641e825.svg";